<template>
	<client-page class="wrap wrap--sub">
        <!-- 서브비주얼 -->
        <sub-visual :visual="'마이페이지'"></sub-visual>
        <mypage-navigation></mypage-navigation>

        <section class="section">
            <v-container>
				<tit-primary
				sc="1:1QNA"
                tit="1:1문의">
                </tit-primary>

                <router-view name="question"></router-view>
            </v-container>
        </section>

	</client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import MypageNavigation from "@/components/client/mypage-navigation.vue";
import TitPrimary from "@/components/client/dumb/tit-primary.vue";

export default {
	components: {
        ClientPage,
		SubVisual,
		MypageNavigation,
		TitPrimary,
	},
	mounted() {
		this.init();
	},
	methods: {
		init: function() {
			if(!this.accessToken){
				this.$router.push('/login');
			}
		}
	},
	computed: {
		accessToken(){
			return this.$store.state.accessToken;
		},
		payload(){
			return this.$store.state.payload || {};
		},
		scope(){
			return this.payload.scope || [];
		}
	}
}
</script>
